import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Input } from '@elevio/elevio-styles/dist/components/hq';

const ObservableInput = ({ fieldId, isEmail, ...rest }) => (
  <Input
    key={`Input_${fieldId}`}
    id={fieldId.toString()}
    size="large"
    type={isEmail ? 'email' : 'text'}
    {...rest}
  />
);

ObservableInput.propTypes = {
  fieldId: PropTypes.number.isRequired,
  isEmail: PropTypes.bool.isRequired,
};

export default observer(ObservableInput);



// WEBPACK FOOTER //
// ./src/components/input/index.js